import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { NgHttpLoaderComponent } from 'ng-http-loader';
import { LoaderComponent } from './pages/common/loader/loader.component';
import { ThemeService } from '../network/services/theme.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, NgHttpLoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'novo-remitall-angular-frontend';
  public awesomeComponent = LoaderComponent;
  deferredPrompt: any;
  showInstallBanner = false;

  private lastFocusedElement: HTMLElement | null = null;
  private wasLoaderVisible = false;
  // currentOrigin: any;

  constructor(
    private _themeService: ThemeService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.getTheme();
    }
  }

  getTheme() {
    if (isPlatformBrowser(this.platformId)) {
      const hostname = window.location.hostname;
      // this.currentOrigin = window.location.origin;
      this._themeService.getUserLogoUrlAndColorCode().subscribe();
    }
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const lastDismissed = localStorage.getItem('pwaBannerDismissedAt');
      const now = new Date().getTime();
      // if (!lastDismissed || now - +lastDismissed > 15 * 24 * 60 * 60 * 1000) {
      window.addEventListener('beforeinstallprompt', (event: any) => {
        event.preventDefault();
        this.deferredPrompt = event;

        const os = this.detectOS();
        if (os == 'Android' || os == 'iOS') {
          this.showInstallBanner = true;
        }
      });
      // }
    }
  }

  installApp(): void {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then((choiceResult: any) => {
        // console.log('User choice:', choiceResult.outcome);
        this.deferredPrompt = null;
        this.showInstallBanner = false;
      });
    }
  }

  detectOS() {
    let userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    return os;
  }

  // Optional: allow user to dismiss banner
  dismissBanner(): void {
    const now = new Date().getTime();
    localStorage.setItem('pwaBannerDismissedAt', now.toString());
    this.showInstallBanner = false;
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (this.isLoaderVisible()) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  ngAfterViewInit(): void {
    // Optional: track loader visibility and add CSS class
    if (isPlatformBrowser(this.platformId)) {
      const loader = document.querySelector('ng-http-loader');
      if (loader) {
        const observer = new MutationObserver(() => {
          const visible = this.isLoaderVisible();
          document.body.classList.toggle('disable-input', visible);
          if (visible && !this.wasLoaderVisible) {
            this.saveAndRemoveFocus();
          } else if (!visible && this.wasLoaderVisible) {
            this.restoreFocus();
          }
          this.wasLoaderVisible = visible;
        });

        observer.observe(loader, {
          childList: true,
          attributes: true,
          subtree: true,
        });
      }
    }
  }

  isLoaderVisible(): boolean {
    const loaderEl = document.querySelector('ng-http-loader');
    if (loaderEl) {
      const spinner = loaderEl.querySelector('.backdrop, .spinner, div'); // adjust if needed
      if (spinner) {
        const style = getComputedStyle(spinner);
        return (
          style.display !== 'none' &&
          +style.opacity > 0 &&
          style.visibility !== 'hidden'
        );
      }
    }
    return false;
  }

  saveAndRemoveFocus(): void {
    const active = document.activeElement as HTMLElement;
    if (active && ['INPUT', 'TEXTAREA', 'SELECT'].includes(active.tagName)) {
      this.lastFocusedElement = active;
      active.blur();
    }
  }

  restoreFocus(): void {
    if (this.lastFocusedElement) {
      this.lastFocusedElement.focus({ preventScroll: true });

      if (
        this.lastFocusedElement instanceof HTMLInputElement ||
        this.lastFocusedElement instanceof HTMLTextAreaElement
      ) {
        const len = this.lastFocusedElement.value.length;
        this.lastFocusedElement.setSelectionRange(len, len);
      } else if (this.lastFocusedElement instanceof HTMLSelectElement) {
        const len = this.lastFocusedElement.selectedIndex;
        this.lastFocusedElement.selectedIndex = len;
      }
      this.lastFocusedElement = null;
    }
  }

  // resetApp() {
  //   this.updatePwaIconFromApi(`${this.currentOrigin}/assets/images/logo.png`);
  // }
  // async updatePwaIconFromApi(apiUrl: string): Promise<void> {
  //   try {
  //     const resizedIconUrlTo192 = await this.resizeImageTo192(apiUrl);
  //     const resizedIconUrlTo512 = await this.resizeImageTo512(apiUrl);
  //     const dynamicManifest = {
  //       name: 'My App',
  //       short_name: 'My App',
  //       id: '/?homescreen=1',
  //       start_url: `${this.currentOrigin}?homescreen=1`,
  //       display: 'standalone',
  //       theme_color: '##3367D6',
  //       background_color: '#ffffff',
  //       description:
  //         'My short project description giving a slightly better idea about my app',
  //       icons: [
  //         {
  //           src: resizedIconUrlTo192,
  //           sizes: '192x192',
  //           type: 'image/png',
  //           purpose: 'any',
  //         },
  //         {
  //           src: resizedIconUrlTo512,
  //           sizes: '512x512',
  //           type: 'image/png',
  //           purpose: 'any',
  //         },
  //       ],
  //     };
  //     this.injectManifest(dynamicManifest);
  //     this.unregisterServiceWorkerAndReload();
  //   } catch (error) {
  //     console.error('Failed to update PWA icon:', error);
  //   }
  // }

  // resizeImageTo192(url: string): Promise<string> {
  //   console.log(url);
  //   return new Promise((resolve, reject) => {
  //     const img = new Image();
  //     img.crossOrigin = 'anonymous'; // CORS if needed
  //     img.onload = () => {
  //       const canvas = document.createElement('canvas');
  //       const ctx = canvas.getContext('2d')!;
  //       canvas.width = 192;
  //       canvas.height = 192;

  //       // Draw the image resized to 192x192
  //       ctx.drawImage(img, 0, 0, 192, 192);

  //       // Convert canvas to Blob and then to object URL
  //       canvas.toBlob((blob) => {
  //         if (!blob) {
  //           reject('Canvas is empty');
  //           return;
  //         }
  //         const blobUrl = URL.createObjectURL(blob);
  //         resolve(blobUrl);
  //       }, 'image/png');
  //     };
  //     img.onerror = () => reject('Failed to load image');
  //     img.src = url + '?not-from-cache-please';
  //   });
  // }

  // resizeImageTo512(url: string): Promise<string> {
  //   return new Promise((resolve, reject) => {
  //     const img = new Image();
  //     img.crossOrigin = 'anonymous'; // CORS if needed
  //     img.onload = () => {
  //       const canvas = document.createElement('canvas');
  //       const ctx = canvas.getContext('2d')!;
  //       canvas.width = 512;
  //       canvas.height = 512;

  //       // Draw the image resized to 512x512
  //       ctx.drawImage(img, 0, 0, 512, 512);

  //       // Convert canvas to Blob and then to object URL
  //       canvas.toBlob((blob) => {
  //         if (!blob) {
  //           reject('Canvas is empty');
  //           return;
  //         }
  //         const blobUrl = URL.createObjectURL(blob);
  //         resolve(blobUrl);
  //       }, 'image/png');
  //     };
  //     img.onerror = () => reject('Failed to load image');
  //     img.src = url;
  //   });
  // }

  // private injectManifest(manifest: any): void {
  //   console.log(manifest);
  //   const existing = document.querySelector('link[rel="manifest"]');
  //   if (existing) document.head.removeChild(existing);

  //   const blob = new Blob([JSON.stringify(manifest)], {
  //     type: 'application/json',
  //   });
  //   const manifestURL = URL.createObjectURL(blob) + `?v=${Date.now()}`;

  //   const link = document.createElement('link');
  //   link.rel = 'manifest';
  //   link.href = manifestURL;
  //   document.head.appendChild(link);
  // }

  // private unregisterServiceWorkerAndReload(): void {
  //   navigator.serviceWorker.getRegistrations().then((registrations) => {
  //     console.log('as', registrations);
  //     this.detectSWUpdate();
  //     registrations.forEach((registration) => {
  //       console.log('as');

  //       registration.unregister().then(() => {
  //         console.log('as');

  //         console.log('Service Worker unregistered');
  //         window.location.reload(); // trigger new manifest loading
  //       });
  //     });
  //   });
  // }

  // async detectSWUpdate() {
  //   const registration = await navigator.serviceWorker.ready;

  //   registration.addEventListener('updatefound', (event) => {
  //     const newSW = registration.installing;
  //     if (newSW) {
  //       newSW.addEventListener('statechange', (event) => {
  //         if (newSW.state == 'installed') {
  //           console.log(newSW.state);
  //           // New service worker is installed, but waiting activation
  //         }
  //       });
  //     }
  //   });
  // }
}
